module.exports = __webpack_public_path__ + "static/media/idea-logo-2026.afaa90b5.svg";